import { ExternalTasksView } from '@/components/tasks/ExternalTasksView';
import { TasksLayout } from '@/components/tasks/TasksLayout';

export const ExternalTasksPage = () => {
  return (
    <TasksLayout>
      <ExternalTasksView />
    </TasksLayout>
  );
};
